import React from 'react';
import { Card } from './ui/Card';
import { ArrowUpIcon, ArrowDownIcon, MinusIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { AreaChart, Area, ResponsiveContainer } from 'recharts';
interface MetricCardProps {
  title: string;
  value: string | number;
  subValue?: string;
  trend?: {
    value: number;
    direction: 'up' | 'down' | 'flat';
    label: string;
  };
  data?: any[]; // For sparkline
  dataKey?: string;
  color?: 'blue' | 'green' | 'indigo' | 'rose';
  delay?: number;
}
export function MetricCard({
  title,
  value,
  subValue,
  trend,
  data,
  dataKey = 'value',
  color = 'blue',
  delay = 0
}: MetricCardProps) {
  const colors = {
    blue: {
      text: 'text-blue-600',
      bg: 'bg-blue-50',
      stroke: '#2563eb',
      fill: '#dbeafe'
    },
    green: {
      text: 'text-emerald-600',
      bg: 'bg-emerald-50',
      stroke: '#059669',
      fill: '#d1fae5'
    },
    indigo: {
      text: 'text-indigo-600',
      bg: 'bg-indigo-50',
      stroke: '#4f46e5',
      fill: '#e0e7ff'
    },
    rose: {
      text: 'text-rose-600',
      bg: 'bg-rose-50',
      stroke: '#e11d48',
      fill: '#ffe4e6'
    }
  };
  const currentColor = colors[color];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay
  }} data-id="element-94">
      <Card className="h-full flex flex-col justify-between hover:shadow-md transition-shadow duration-200" data-id="element-95">
        <div className="flex justify-between items-start mb-2" data-id="element-96">
          <h3 className="text-sm font-medium text-slate-500" data-id="element-97">{title}</h3>
          {trend && <div className={`flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${trend.direction === 'up' ? 'bg-green-100 text-green-700' : trend.direction === 'down' ? 'bg-red-100 text-red-700' : 'bg-slate-100 text-slate-700'}`} data-id="element-98">
              {trend.direction === 'up' && <ArrowUpIcon className="w-3 h-3 mr-1" data-id="element-99" />}
              {trend.direction === 'down' && <ArrowDownIcon className="w-3 h-3 mr-1" data-id="element-100" />}
              {trend.direction === 'flat' && <MinusIcon className="w-3 h-3 mr-1" data-id="element-101" />}
              {trend.value}%
            </div>}
        </div>

        <div className="flex items-end justify-between" data-id="element-102">
          <div data-id="element-103">
            <div className="text-2xl font-bold text-slate-900" data-id="element-104">{value}</div>
            {subValue && <div className="text-xs text-slate-500 mt-1" data-id="element-105">{subValue}</div>}
            {trend && <div className="text-xs text-slate-400 mt-1" data-id="element-106">{trend.label}</div>}
          </div>

          {data && data.length > 0 && <div className="h-12 w-24 -mb-2 -mr-2" data-id="element-107">
              <ResponsiveContainer width="100%" height="100%" data-id="element-108">
                <AreaChart data={data} data-id="element-109">
                  <Area type="monotone" dataKey={dataKey} stroke={currentColor.stroke} fill={currentColor.fill} strokeWidth={2} data-id="element-110" />
                </AreaChart>
              </ResponsiveContainer>
            </div>}
        </div>
      </Card>
    </motion.div>;
}